import SessionStore from '../stores/SessionStore.js'
import commonUtils from '../utils/commonUtils.js';
import constants from '../utils/constants.js';

import useStores from './useStores.js';

const {GAME_LENGTH} = constants;

function Header() {
  useStores([SessionStore]);

  const cardCount = SessionStore.getCardCount();
  const failureCount = SessionStore.getFailureCount();
  const elapsedTime = SessionStore.getElapsedTime();
  const timeDisplay = commonUtils.getDisplayTime(elapsedTime);

  const failureClass = failureCount ? 'failure-count-error' : 'failure-count-ok';

  let message = 'not yet started';
  if (cardCount) {
    message = (<>
      {' '}{cardCount} of {GAME_LENGTH}
      {' | '}
      <i class="fa-regular fa-hourglass"></i> {timeDisplay}
      {' | '}
      <span class={failureClass}>
        <i class="fa-solid fa-bomb"></i> {failureCount}
      </span>
    </>);
  }

  return (
    <div className="top">
      Violin App | {message}
    </div>
  );
}

export default Header;
